import ConsultedSourcesSection from './ConsultedSourcesSection'

export default ConsultedSourcesSection
